import styled from 'styled-components';

export const SpanStyle = styled.p`
	float: left;
	margin: -0.2rem !important;
`;

export const BagdeStyle = styled.span`
	background-color: #80808061 !important;
`;
export const CardBody = styled.span`
	padding:10px;
	overflow-y: hidden;

`;
export const Card = styled.span`

`;
